module.exports = __webpack_public_path__ + "img/p01.e75ae593.jpg";